import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import style from './usos-layout.scss';

/**
 * Basis of app view.
 */
@customElement('usos-layout')
export class UsosLayout extends LitElement {
    static override styles = style;

    /** Should app width be expanded to fit the browser viewport? */
    @property({reflect: true, type: Boolean}) expanded = false;

    /** Should app width be responsive? */
    @property({reflect: true, type: Boolean}) responsive = false;

    override render() {
        return html`
            <slot></slot>
        `;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    override updated(changedProperties: Map<string, any>) {
        if (changedProperties.has('responsive')) {
            const appHeader = this.querySelector('app-header');
            if (appHeader) appHeader.responsive = this.responsive;
            const mainPanel = this.querySelector('main-panel');
            if (mainPanel) mainPanel.responsive = this.responsive;
        }
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "usos-layout": UsosLayout,
    }
}
